import NotificationsRepository from "@/core/notifications/repositories/NotificationsRepository";
import type { NotificationsListResponse } from "@/core/notifications/entities/Notification";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import type Exception from "@/core/exceptions/Exception";

export default class GetNotificationsUseCase {
  constructor(
    private readonly notificationsRepository: NotificationsRepository,
  ) {}

  async execute(): Promise<NotificationsListResponse> {
    const result = await this.notificationsRepository.getNotifications();

    if (result.success && result.data) {
      return {
        code: "200",
        message: "OK",
        data: result.data.items,
        unreadCount: result.data.unreadCount,
      };
    }

    if (result.exception) {
      throw result.exception;
    }

    const error = new Error("No notifications returned") as Error & Exception;
    error.type = DefaultExceptionTypes.UNKNOWN_ERROR;
    throw error;
  }
}
